import { Profile } from '@/types'
import { globalState } from '@codeleap/store'

type StoreType = Record<keyof Profile, any>

export const store = globalState<StoreType>({} as StoreType)

export function answerPrompt<T extends keyof Profile>(prompt: T, value: Profile[T]) {
  store.set({ [prompt]: value })
}

export function isAnswered(prompt: keyof Profile) {
  return !!store.get()?.[prompt]
}

export function usePromptAnswer(prompt: keyof Profile) {
  return store.use(s => !!s?.[prompt])
}

export function reset() {
  store.reset({} as StoreType)
}
